/**
 * Words the Agent's own screens say that the settings navigation used to own.
 *
 * The settings page is the shell's now and names its sections with panel keys;
 * these stay because Agent code still renders them — the Secrets list's
 * "Workspace" group, the save bar's Discard, member and plan labels.
 *
 * One half of `AGENT_COPY`. The shape and the rules are documented on the
 * barrel in `../agent-copy.ts`; this file only holds entries.
 */
export const SETTINGS: Record<string, string> = {
	Personal: "个人",
	Account: "账户",
	Workspace: "工作区",
	Discard: "放弃更改",
	Profile: "个人资料",
	Language: "语言",
	Members: "成员",
	Subscription: "订阅",
	Voice: "语气",
	Secrets: "密钥",
};
